import React from 'react';

import ADBannerCarousel from '@components/shared/ADBannerCarousel/ADBannerCarousel';
import LastTransaction from '@components/shared/LastTransaction/LastTransaction';
import OverdraftInfo from '@components/shared/OverdraftInfo/OverdraftInfo';
import QuickActions from '@components/shared/QuickActions/QuickActions';
import ResourcesSummary from '@components/shared/ResourcesSummary/ResourcesSummary';
import SupportManagers from '@components/shared/SupportManagers/SupportManagers';
import UserData from '@components/shared/UserData/UserData';
import { useResponsive } from '@hooks/shared/useResponsive';
import { Container } from '@styled/shared/Container';
import { Flex } from 'antd';

const Home = () => {
	const { mobileOnly } = useResponsive();

	return (
		<Container vertical gap={16}>
			<ADBannerCarousel />
			<ResourcesSummary />
			<QuickActions />
			<Flex vertical={mobileOnly} gap={16}>
				<UserData />
				<SupportManagers />
			</Flex>
			<OverdraftInfo />
			<LastTransaction />
		</Container>
	);
};

export default Home;
